export default "__VITE_ASSET__$rKU$0hF__"